<template>
    <v-layout>
      <v-flex>
      <v-card>
        <v-card-title>
          <h3>{{title}}</h3>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="fal fa-search"
            placeholder="Search"
            single-line
            hide-details
            clearable>
          </v-text-field>
        </v-card-title>
        <v-data-table
          :options.sync="pagination"
          :headers="headers"
          :items="datasource"
          :search="search"
          :loading="myloading"
          v-model="selectionModel"
          :show-select="selection"
          @input="emit"
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td v-if="selection">
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td>{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.login }}</td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" type="warning">
              Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
      </v-flex>
    </v-layout>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    datasource: Array,
    title: String,
    rowsPerPage: Number,
    loading: Boolean,
    selection: Boolean,
    showId: Boolean,
    reset: Boolean,
    initSearch: String
  },
  watch: {
    reset: function (updatedValue) {
      this.selectionModel = []
    }
  },
  data() {
    return {
      myloading: this.loading,
      selectionModel: [],
      headers: [
          {text: 'Id', align: 'left', sortable: true, value: 'id'},
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Login', align: 'left', sortable: true, value: 'login'}
      ],
      pagination: {
        rowsPerPage: this.rowsPerPage
      },
      search: ''
    }
  },
  created() {
    if (this.showId) {
      headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }
    if (this.initSearch) {
      this.search = this.initSearch
    }
  },
  methods: {
    getAliases(aliases) {
      if (!aliases) {
        return ''
      }
      let tokens = _.split(aliases, '/')
      return _.join(_.without(tokens, ''), ', ')
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    emit(data) {
      this.$emit('selectionChanged', data)
    }
  }
}
</script>
